/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { interactionChannelSchema } from "./interactionChannelSchema";
import { z } from "zod/v4";

export const interactionChannelDtoSchema = z.object({
    get "type"(){
                return interactionChannelSchema.describe("Channel through which the interaction took place (e.g. email ingestion, call log, manual note).")
              },
"referenceId": z.optional(z.string().describe("Internal reference for this channel (e.g. `emails.id` UUID when type is email).")),
"provider": z.optional(z.string().describe("Provider name for the underlying artifact (for email: `EmailEntity.provider`, e.g. \"gmail\").")),
"providerId": z.optional(z.string().describe("Provider-native identifier for the underlying artifact (for email: `EmailEntity.providerMessageId`, e.g. Gmail message id)."))
    })